import {EntityService} from '../../service/EntityService';

export class LogService extends EntityService {

  static entity = 'api/app/action-log';
}
